import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { FooterLinksStack } from './FooterLinks.styles';
import GooglePlayBadge from 'molecules/AppStoreBadges/GooglePlayBadge';
import AppStoreBadge from 'molecules/AppStoreBadges/AppStoreBadge';
import {
  LinkGroup as LinkGroupType,
  PRODUCT_LINKS,
  MIGHTY_PRO_LINKS,
  RESOURCES_LINKS,
  COMPANY_LINKS,
  COMPARISON_LINKS,
} from './FooterLinkData';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import LinkGroup from './LinkGroup';

const FooterLinksMobile = (): JSX.Element => {
  const renderLinkGroups = (linkGroups: LinkGroupType[]) => {
    return linkGroups.map((linkGroup) => (
      <LinkGroup
        key={`link-group-${linkGroup.title}`}
        {...linkGroup}
      />
    ));
  };

  return (
    <Grid
      gap='spacing-4xl'
      totalColumns={2}
      maxWidth='width-lg'
      maxWidthLg='width-lg'
      padding={['spacing-6xl', 'spacing-none', 'spacing-none', 'spacing-none']}
      showOn='lg'
    >
      <FooterLinksStack
        direction='column'
        gap='spacing-4xl'
        justify='space-between'
        align='flex-start'
        textColor='text-quaternary-on-brand'
      >
        {renderLinkGroups([PRODUCT_LINKS, MIGHTY_PRO_LINKS])}
      </FooterLinksStack>
      <FooterLinksStack
        direction='column'
        gap='spacing-4xl'
        justify='space-between'
        align='flex-start'
        textColor='text-quaternary-on-brand'
      >
        {renderLinkGroups([RESOURCES_LINKS])}
      </FooterLinksStack>
      <FooterLinksStack
        direction='column'
        gap='spacing-4xl'
        justify='space-between'
        align='flex-start'
        textColor='text-quaternary-on-brand'
      >
        {renderLinkGroups([COMPANY_LINKS])}
      </FooterLinksStack>
      <FooterLinksStack
        direction='column'
        gap='spacing-4xl'
        justify='space-between'
        align='flex-start'
        textColor='text-quaternary-on-brand'
      >
        {renderLinkGroups([COMPARISON_LINKS])}
      </FooterLinksStack>
      <FooterLinksStack
        columns={2}
        direction='column'
        gap='spacing-4xl'
        justify='space-between'
        align='flex-start'
        textColor='text-quaternary-on-brand'
        flex='0 0 136px'
      >
        <Stack
          direction='row'
          gap='spacing-2xl'
          align='flex-start'
          justify='flex-start'
        >
          <AppStoreBadge />
          <GooglePlayBadge />
        </Stack>
      </FooterLinksStack>
    </Grid>
  );
};

export default FooterLinksMobile;
